import React from 'react'
import styles from './index.less'
export { handelClickOlineSoidAfterSaleCountInAfterSale, handelClickOlineSoidAfterSaleCountInOrder } from './helper'

interface OlineSoidAfterSaleCountLinkType {
    count: number
    handelClick: any
}

const OlineSoidAfterSaleCountLink = (props: OlineSoidAfterSaleCountLinkType) => {
    const { count, handelClick = () => {} } = props

    return (
        <a onClick={handelClick}>
            <img
                className={styles.icon}
                src="https://assets.sursung.com/activity/20230925/CFBA291BB379430CA35A542E3511EBD71695608637807.svg"
            />
            {count}笔售后单
        </a>
    )
}

export default OlineSoidAfterSaleCountLink
